var _defs, _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresentLongSectionSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aeaeb6;}.cls-2{fill:#363545;}.cls-3{fill:none;stroke:#be1e2d;stroke-miterlimit:10;stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PresentLongSection_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.26,19.2,17.32,18c-2.63-.79-2.88-.86-3.58-.85A10.1,10.1,0,0,0,8,19.45V26H32V19.55a6.16,6.16,0,0,1-.94.59C28.73,21.32,26.37,20.7,21.26,19.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.17,18.36c-1.6.79-3.35.39-8.34-1.08L17.9,16.11c-2.7-.82-3.19-1-4.22-.94A11.42,11.42,0,0,0,8,17V2H6V26H2v2H6v4H8V28H32V26H8V19.45a10.1,10.1,0,0,1,5.74-2.28c.7,0,.95.06,3.58.85l3.94,1.18c5.11,1.5,7.47,2.12,9.8.94a6.16,6.16,0,0,0,.94-.59V16.72A5.16,5.16,0,0,1,30.17,18.36Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -112.15,
    y: -58.62,
    width: 307.49,
    height: 95.32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentLongSectionSvg);
export default __webpack_public_path__ + "static/media/PresentLongSection_svg.1c8e15e832556625f1cae13e57ede50b.svg";
export { ForwardRef as ReactComponent };